import {
	VALIDATION_REQUIRED,
	VALIDATION_PATTERN_EMAIL,
	VALIDATION_PATTERN_PHONE,
	VALIDATION_PATTERN_DATE
} from "utils/validation";

const UNIT_FORM_INPUTS = {
	firstName: {
		name: "firstName",
		type: "text",
		label: "First Name",
		className: "firstName",
		errorMessage: "Please enter a first name",
		required: true,
		registerOptions: {
			...VALIDATION_REQUIRED
		}
	},
	lastName: {
		name: "lastName",
		type: "text",
		label: "Last Name",
		className: "lastName",
		errorMessage: "Please enter a last name",
		required: true,
		registerOptions: {
			...VALIDATION_REQUIRED
		}
	},
	email: {
		name: "email",
		type: "email",
		label: "Email Address",
		className: "email",
		errorMessage: "Please enter a valid email address",
		required: true,
		registerOptions: {
			...VALIDATION_REQUIRED,
			...VALIDATION_PATTERN_EMAIL
		}
	},
	phoneNumber: {
		name: "phoneNumber",
		type: "tel",
		label: "Phone Number",
		className: "phoneNumber",
		errorMessage: "Please enter a valid phone number",
		required: true,
		registerOptions: {
			...VALIDATION_REQUIRED,
			...VALIDATION_PATTERN_PHONE
		}
	},
	moveInDate: {
		name: "moveInDate",
		type: "text",
		label: "Expected Move-In Date",
		className: "moveInDate",
		errorMessage: "Please enter a valid move in date",
		helpText:
			"If you're unsure of your move-in date, select an estimated date. This can be changed later.",
		required: true,
		registerOptions: {
			...VALIDATION_REQUIRED,
			...VALIDATION_PATTERN_DATE
		}
	}
};

const ADDITIONAL_NAMES_FIELD_ARRAY_NAME = "alternateNames";

const ADDITIONAL_NAME_INPUTS = {
	additionalFirstName: (index) => ({
		// this FIELD_ARRAY_NAME.INDEX.NAME format is required by RHF.
		name: `${ADDITIONAL_NAMES_FIELD_ARRAY_NAME}.${index}.firstName`,
		type: "text",
		label: "First Name",
		errorMessage: "Please enter a first name",
		registerOptions: {
			...VALIDATION_REQUIRED
		}
	}),
	additionalLastName: (index) => ({
		// this FIELD_ARRAY_NAME.INDEX.NAME format is required by RHF.
		name: `${ADDITIONAL_NAMES_FIELD_ARRAY_NAME}.${index}.lastName`,
		type: "text",
		label: "Last Name",
		errorMessage: "Please enter a last name",
		registerOptions: {
			...VALIDATION_REQUIRED
		}
	})
};

export {
	UNIT_FORM_INPUTS,
	ADDITIONAL_NAME_INPUTS,
	ADDITIONAL_NAMES_FIELD_ARRAY_NAME
};
